import { render, staticRenderFns } from "./playerTeam.vue?vue&type=template&id=64936dc4&scoped=true&"
import script from "./playerTeam.vue?vue&type=script&lang=js&"
export * from "./playerTeam.vue?vue&type=script&lang=js&"
import style0 from "./playerTeam.vue?vue&type=style&index=0&id=64936dc4&lang=scss&scoped=true&"
import style1 from "./playerTeam.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64936dc4",
  null
  
)

export default component.exports